import React, { useState } from "react";
import { fetchWithAuth } from "../utils/fetchWithAuth";
import { SERVER_URL } from "../config";

const ProviderSignup: React.FC = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [email, setEmail] = useState("");
  const [region, setRegion] = useState("");
  const [passwordHash, setPasswordHash] = useState("");
  const [confirmPasswordHash, setConfirmPasswordHash] = useState("");
  const [clinicCode, setClinicCode] = useState<string | undefined>(undefined);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (passwordHash !== confirmPasswordHash) {
      setError("PasswordHashs do not match!");
      return;
    }

    try {
      const response = await fetchWithAuth(
        `${SERVER_URL}/api/auth/provider/signup`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            firstName,
            lastName,
            email,
            region,
            passwordHash,
            clinicCode,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        alert("Provider registered successfully!");
        setFirstName("");
        setlastName("");
        setEmail("");
        setRegion("");
        setPasswordHash("");
        setConfirmPasswordHash("");
        setClinicCode(undefined);
        setError(null);
      } else {
        setError(data.error || "Failed to register provider");
      }
    } catch (err) {
      console.error("Sign-up error:", err);
      setError("An error occurred while signing up.");
    }
  };

  return (
    <div
      style={{
        padding: "2rem",
        maxWidth: "400px",
        margin: "0 auto",
        color: "black",
        border: "1px solid #ccc",
        borderRadius: "8px",
        background: "#f9f9f9",
      }}
    >
      <h2>Provider Sign Up</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
      >
        <div>
          <label
            htmlFor="FirstName"
            style={{ display: "block", marginBottom: "0.5rem" }}
          >
            FirstName
          </label>
          <input
            type="text"
            id="FirstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            style={{
              width: "100%",
              padding: "0.5rem",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
            required
          />
        </div>
        <div>
          <label
            htmlFor="lastName"
            style={{ display: "block", marginBottom: "0.5rem" }}
          >
            Last Name
          </label>
          <input
            type="text"
            id="lastName"
            value={lastName}
            onChange={(e) => setlastName(e.target.value)}
            style={{
              width: "100%",
              padding: "0.5rem",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
            required
          />
        </div>
        <div>
          <label
            htmlFor="email"
            style={{ display: "block", marginBottom: "0.5rem" }}
          >
            Email
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              width: "100%",
              padding: "0.5rem",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
            required
          />
        </div>
        <div>
          <label
            htmlFor="state"
            style={{ display: "block", marginBottom: "0.5rem" }}
          >
            State
          </label>
          <input
            type="text"
            id="state"
            value={region}
            onChange={(e) => setRegion(e.target.value)}
            style={{
              width: "100%",
              padding: "0.5rem",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
            required
          />
        </div>
        <div>
          <label
            htmlFor="clinicCode"
            style={{ display: "block", marginBottom: "0.5rem" }}
          >
            Clinic Code
          </label>
          <input
            type="text"
            id="clinicCode"
            value={clinicCode || ""}
            onChange={(e) => setClinicCode(e.target.value || undefined)}
            style={{
              width: "100%",
              padding: "0.5rem",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        </div>
        <div>
          <label
            htmlFor="password"
            style={{ display: "block", marginBottom: "0.5rem" }}
          >
            PasswordHash
          </label>
          <input
            type="password"
            id="password"
            value={passwordHash}
            onChange={(e) => setPasswordHash(e.target.value)}
            style={{
              width: "100%",
              padding: "0.5rem",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
            required
          />
        </div>
        <div>
          <label
            htmlFor="confirmPassword"
            style={{ display: "block", marginBottom: "0.5rem" }}
          >
            Confirm PasswordHash
          </label>
          <input
            type="password"
            id="confirmPassword"
            value={confirmPasswordHash}
            onChange={(e) => setConfirmPasswordHash(e.target.value)}
            style={{
              width: "100%",
              padding: "0.5rem",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
            required
          />
        </div>
        <button
          type="submit"
          style={{
            padding: "0.5rem",
            background: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Sign Up
        </button>
      </form>
    </div>
  );
};

export default ProviderSignup;
